import { ComponentProps, useState } from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { LandingPage } from './LandingPage'
import PayrollWizard from './PayrollWizard'

const SelfServicePage = () => {
  const [showWizardModal, setShowWizardModal] = useState<boolean>(false)

  const actions: ComponentProps<typeof ResponsivePage.Body>['transactionalActions'] = {
    primary: {
      label: i18n.t('payroll_bundle.onboarding.welcome_step.cta_button'),
      onClick: () => {
        setShowWizardModal(true)
      },
    },
  }

  return (
    <ResponsivePage.Body showHeader={false} transactionalActions={actions}>
      <LandingPage />
      {showWizardModal && <PayrollWizard onClose={() => setShowWizardModal(false)} />}
    </ResponsivePage.Body>
  )
}

export default observer(SelfServicePage)
